var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Copyright: Adrián Monzón | "),_c('a',{attrs:{"href":"/validar-usuario"}},[_vm._v("Administración")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }